<template>
  <div class="cat-domain">
    <NavigationBar />
    <div class="domain-header">
      <div class="cl-container title">
        {{ $t('common.sam_assignment') }}
        <img src="/static/images/ic-info-outline-black.svg" 
          class="icon" 
          alt="classting-score" 
          v-b-modal.catDomainGuide />
      </div>

      <SubHeaderTab
        :items="catSubjects"
        :selectedId="selectedSubject"
        @selectedTab="selectedTab"
      />
    </div>

    <LoadingBounce v-if="busy" />
    <template v-else>
      <div class="domain-cover">
        <div class="cl-container cover-container">
          <div class="cover-icon">
            <img src="/static/images/img-main-sam.png" alt="sam">
          </div>
          <div class="cover-description">
            <span v-if="busy">{{ $t('common.sam_loading') }}</span>
            <span v-else v-html="getCatDescription"></span>
          </div>
        </div>
      </div>

      <div class="domain-container">
        <div class="domain-title">{{ $t('common.domain') }} {{ catSubjectDomainsLength }}</div>
        <div class="row px-14">
          <div class="col-lg-12 col-xs-12 col-md-12" v-if="busy">
            <LoadingBounce />
          </div>
          <template v-else>
            <EmptyContent v-if="catSubjectDomainsLength === 0"
              :emptyContentText="$t('common.empty_domain_assignment')" />
            <div v-else
              class="col-lg-6 col-xs-12 col-md-12 domain"
              v-for="(value, index) in filterCatSubjectDomains" :key="index">
              <div class="domain-state-icon"
                v-if="value.cat && (value.cat.is_first_cat || !value.cat.is_completed)" 
                :style="{ 'border-bottom-color': selectedSubjectColor }"></div>
              <div class="cl-card">
                <div class="domain-name">{{ value.name }}</div>
                <div class="domain-state">
                  <template v-if="!value.cat">
                    <div class="row">
                      <div class="col-8 domain-progress">
                        {{ $t('domain.need_first_problem_solve') }}
                      </div>
                      <div class="col-4 domain-action" :style="{ 'color': selectedSubjectColor }">
                        <span @click="openCreatedLearningViewer(value.id, true)">
                          {{ $t('common.first_problem_solve') }} &gt;
                        </span>
                      </div>
                    </div>
                    <progress-bar class="domain-progress-bar"
                      :value="0" 
                      :bgColor="selectedSubjectColor" 
                      :height="6" />
                  </template>

                  <template v-else-if="value.cat && value.cat.is_completed">
                    <div class="row" :style="{ 'padding': '16px 0px 16px 0px' }">
                      <div class="col-8 domain-score">
                        {{ $t('common.recent_score') }} 
                        <span :style="{ 'color': selectedSubjectColor }">
                          {{ value.proficiency_score || '-' }}{{ $t('common.score_value') }}
                        </span> 
                        {{ $t('common.rank') }}
                        <template v-if="isGradeTotal(value.rank && value.rank.grade_total)">
                          <span :style="{ 'color': selectedSubjectColor }">
                            {{ quizProgressValue(value.rank && value.rank.grade_position, value.rank && value.rank.grade_total) || '-' }}%
                          </span>
                        </template>
                        <template v-else>
                          <span :style="{ 'color': selectedSubjectColor }">-%</span> 
                          {{ $t('common.standard_before_update') }}
                        </template>
                      </div>
                      <div class="col-4 domain-action" :style="{ 'color': '#00C896' }">
                        <span @click="openCreatedLearningViewer(value.id, false)">
                          {{ $t('common.problem_solve') }} &gt;
                        </span>
                      </div>
                    </div>
                  </template>

                  <template v-else-if="value.cat && value.cat.is_first_cat">
                    <div class="row">
                      <div class="col-8 domain-progress" :style="{ 'color': selectedSubjectColor }">
                        {{ quizProgressValue(value.cat.quiz_results.length, value.cat.quiz_count) }}% 
                        {{ $t('common.first_problem_prgress') }}
                      </div>
                      <div class="col-4 domain-action" :style="{ 'color': selectedSubjectColor }">
                        <span @click="openLearningViewer(value.cat && value.cat.viewer_url, true)">
                          {{ $t('common.continu_solve') }} &gt;
                        </span>
                      </div>
                    </div>

                    <progress-bar class="domain-progress-bar"
                      :value="quizProgressValue(value.cat.quiz_results.length, value.cat.quiz_count)" 
                      :bgColor="selectedSubjectColor" 
                      :height="6" />
                  </template>

                  <template v-else-if="value.cat && !value.cat.is_completed">
                    <div class="row" :style="{ 'padding': '16px 0px 16px 0px' }">
                      <div class="col-8 domain-score">
                        {{ $t('common.recent_score') }} 
                        <span :style="{ 'color': selectedSubjectColor }">
                          {{ value.proficiency_score || '-' }}{{ $t('common.score_value') }}
                        </span> 
                        {{ $t('common.rank') }}
                        <template v-if="isGradeTotal(value.rank && value.rank.grade_total)">
                          <span :style="{ 'color': selectedSubjectColor }">
                            {{ quizProgressValue(value.rank && value.rank.grade_position, value.rank && value.rank.grade_total) || '-' }}%
                          </span>
                        </template>
                        <template v-else>
                          <span :style="{ 'color': selectedSubjectColor }">-%</span> {{ $t('common.standard_before_update') }}
                        </template>
                      </div>
                      <div class="col-4 domain-action" :style="{ 'color': selectedSubjectColor }">
                        <span @click="openLearningViewer(value.cat && value.cat.viewer_url)">
                          {{ $t('common.continu_solve') }} &gt;
                        </span>
                      </div>
                    </div>
                  </template>
                </div>
              </div>
            </div>
          </template>
          <InfiniteLoading v-if="filterCatSubjectDomains.length >= 10" @infinite="infiniteHandler" class="w-100">
            <div slot="spinner">
              <LoadingBounce></LoadingBounce>
            </div>
            <span slot="no-results"></span>
            <span slot="no-more"></span>
          </InfiniteLoading>
        </div>
      </div>
    </template>

    <CatDomainGuide id="catDomainGuide" />

    <PrimeSnackBar v-if="isSnackBar"
      @okSnackBar="okSnackBar()"
      @closeSnackBar="closeSnackBar()" />

    <PrimeModal v-if="isPrimeModal"
      @closeModal="closePrimeModal()"
      @okModal="okPrimeModal()"
      :benefitTitle="$t('prime.first_solve_complete')"
      :isUnsupportText="true" />

    <LicenceModal v-if="isLicenceModal"
      @ok="isLicenceModal = false" />

  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';
  import { isEmpty, get } from 'lodash';
  import InfiniteLoading from 'vue-infinite-loading';
  import { CLASSTING_PAY_WEB } from '@/config';

  import CatSubtitle from '../../cat-main/components/CatSubtitle';
  import CatDomainGuide from '../../cat-main/components/CatDomainGuide';
  import PrimeModal from '../../cat-main/components/PrimeModal';

  export default {
    name: 'cat-domain',

    data() {
      return {
        selectedSubject: 0,
        selectedSubjectColor: '#03a9f4',
        busy: false,
        limit: 10,
        isPrimeModal: false,
        isSnackBar: false,
        isLicenceModal: false,
      };
    },

    components: {
      CatSubtitle,
      CatDomainGuide,
      InfiniteLoading,
      PrimeModal,
    },

    computed: {
      ...mapGetters({
        catSubjects: 'getCatSubjects',
        catSubjectDomains: 'getCatSubjectDomains',
        selectedSubjectId: 'getSelectedSubjectId',
        catStats: 'getCatStats',
        subjectDomainPosition: 'getSubjectDomainPosition',
        isSubscriptionUser: 'isSubscriptionUser',
        isPrimeSupportCountry: 'isPrimeSupportCountry',
      }),

      filterCatSubjectDomains() {
        return this.catSubjectDomains && this.catSubjectDomains[this.selectedSubject];
      },

      catSubjectDomainsLength() {
        return this.filterCatSubjectDomains && this.filterCatSubjectDomains.length;
      },

      filterCatStats() {
        return this.catStats && this.catStats[this.selectedSubject];
      },

      completedCats() {
        return this.filterCatStats && this.filterCatStats.completed_cats;
      },

      completedDomains() {
        return this.filterCatStats && this.filterCatStats.completed_domains;
      },

      getCatDescription() {
        const minCompletedCats = 5;
        if (this.completedCats > minCompletedCats) {
          return this.$t('domain.current_problem_count', { count: this.completedCats });
        }

        return this.$t('domain.complete_problem', { count: this.completedDomains });
      },

      filterSubjectDomainPosition() {
        return this.subjectDomainPosition[this.selectedSubject];
      },
    },

    methods: {
      ...mapActions([
        'fetchCatDomains',
        'fetchSubjects',
        'fetchCatStats',
        'creatCatCard',
        'fetchCatConfigs',
        'resetCatSubjectDomains',
      ]),

      showPrime() {
        if (this.$mobile.isClasstingClient()) {
          return this.$mobile.openNewWebView(CLASSTING_PAY_WEB);
        }

        return window.open(CLASSTING_PAY_WEB);
      },

      okPrimeModal() {
        this.$ga.event({
          eventCategory: 'prime',
          eventLabel: 'modal_preview_cat',
          eventAction: 'click',
        });

        this.isPrimeModal = false;
        this.showPrime();
      },

      closePrimeModal() {
        this.isPrimeModal = false;
        return true;
      },

      okSnackBar() {
        this.$ga.event({
          eventCategory: 'prime',
          eventLabel: 'snackbar_cats',
          eventAction: 'click',
        });

        this.isSnackBar = false;
        this.showPrime();
      },

      openSnackBar() {
        this.isSnackBar = true;
      },

      closeSnackBar() {
        this.isSnackBar = false;
      },

      setDomainEventCount(count) {
        return this.$localStorage.set('domainEventCount', count);
      },

      getDomainEventCount() {
        return Number(this.$localStorage.get('domainEventCount') || 0);
      },

      selectedTab(selected) {
        this.$ga.event({
          eventCategory: 'cats',
          eventAction: 'click.subject',
          eventLabel: selected.id,
        });

        this.selectedSubject = selected.id;
        this.selectedSubjectColor = selected.color_code;
      },

      openLearningViewer(viewerUrl, isFirstCatQuiz) {
        this.$ga.event({
          eventCategory: 'cats',
          eventAction: 'click.domain',
        });

        if (!this.isSubscriptionUser && !isFirstCatQuiz) {
          this.$ga.event({
            eventCategory: 'recommended_lectures',
            eventLabel: 'cat',
            eventAction: 'preview',
          });

          if (this.isPrimeSupportCountry) {
            this.isPrimeModal = true;
            return true;
          }

          this.isLicenceModal = true;
          return true;
        }

        if (this.$mobile.isClasstingClient()) {
          return this.$mobile.openNewWebView(viewerUrl);
        }

        const viewer = window.open(viewerUrl);
        const delay = setInterval(() => {
          if (viewer.closed) {
            clearInterval(delay);
            this.resetCatSubjectDomains();
            const filters = {};
            filters.subject_id = this.selectedSubject;
            this.fetchCatDomains(filters);
          }
        }, 1000);

        return true;
      },

      quizProgressValue(value, total) {
        return Number(((value / total) * 100).toFixed(0)) || 0;
      },

      isGradeTotal(gradeTotal) {
        return gradeTotal >= 10;
      },

      openCreatedLearningViewer(domainId, isFirstCatQuiz) {
        this.fetchCatConfigs()
          .then((catConfigs) => {
            if (isFirstCatQuiz) {
              return this.creatCatCard({ domainId, quizCount: catConfigs.first_cat_quiz_count });
            }

            if (this.isSubscriptionUser) {
              return this.creatCatCard({ domainId, quizCount: catConfigs.normal_cat_quiz_count });
            }

            return true;
          })
          .then(data => (
            this.openLearningViewer(data.viewer_url, isFirstCatQuiz)
          ));
      },

      infiniteHandler($state) {
        const filters = {};
        filters.page = this.filterSubjectDomainPosition;
        filters.per_page = this.limit;
        filters.subject_id = this.selectedSubject;

        this.fetchCatDomains(filters)
          .then((data) => {
            if (data.length > 0) {
              $state.loaded();
            } else {
              $state.complete();
            }
          });
      },
    },

    beforeMount() {
      this.$route.meta.title = this.$t('common.sam_assignment');
      this.resetCatSubjectDomains();
      this.busy = true;
      const filters = {};
      filters.page = 1;
      filters.per_page = this.limit;

      Promise.resolve()
        .then(() => {
          if (isEmpty(this.catSubjects)) {
            return this.fetchSubjects();
          }
          return true;
        })
        .then(() => {
          this.selectedSubject = get(this.catSubjects, '0.id', 0);
          filters.subject_id = get(this.catSubjects, '0.id', 0);
          return true;
        })
        .then(() => (
          this.fetchCatStats(filters)
        ))
        .then(() => {
          if (!this.isSubscriptionUser && !this.getDomainEventCount()) {
            return this.setDomainEventCount(1);
          }

          if (!this.isSubscriptionUser && this.getDomainEventCount()) {
            const eventCount = this.getDomainEventCount() + 1;
            return this.setDomainEventCount(eventCount);
          }

          return true;
        })
        .then(() => {
          if (!this.isSubscriptionUser &&
            this.isPrimeSupportCountry &&
            this.getDomainEventCount() >= 15) {
            this.$ga.event({
              eventCategory: 'prime',
              eventLabel: 'snackbar_cats',
              eventAction: 'view',
            });
            this.$localStorage.set('domainEventCount', 0);
            this.openSnackBar();
            return true;
          }
          return true;
        })
        .then(() => {
          this.busy = false;
        });
    },

    watch: {
      selectedSubject(selected) {
        const filters = {};
        filters.subject_id = selected;
        this.fetchCatStats(filters)
          .then(() => {
            if (!this.catSubjectDomains[selected]) {
              this.busy = true;
              this.fetchCatDomains(filters)
                .then(() => {
                  this.busy = false;
                });
            }
          });
      },
    },
  };
</script>

<style lang="scss" scoped>
  .cat-domain {
    .domain-header {
      height: 100px;
      width: 100%;
      background-color: #ffffff;
      box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.1);
      padding: 24px;

      .title {
        font-size: 20px;
        font-weight: bold;
        color: rgba(0, 0, 0, 0.54);
        padding: 0px 14px 0px 14px;

        .icon {
          float: right;
          cursor: pointer;
          width: 20px;
          height: 20px;
        }
      }

      .subject {
        text-align: center;
        display: inline-block;
        padding: 4px 44px 4px 44px;
        font-weight: bold;
        cursor: pointer;
        color: rgba(0, 0, 0, 0.4);
        font-size: 14px;

        &:hover {
          color: #00C896;
        }

        &.active {
          color: #00C896;
          border-bottom: 2px solid #00C896;
        }
      }
    }

    .domain-cover {
      position: relative;
      background: url('/static/images/img-sam-assignment.png') center center;
      height: 8%;
      background-repeat: no-repeat;
      background-size: cover;

      @media (max-width: 375px) {
        height: 120px;
      }

      .cover-container {
        padding-top: 8%;

        @media (max-width: 375px) {
          padding-top: 18%;
        }

        .cover-icon {
          display: inline-block;
          padding: 0px 14px 0px 14px;

          img {
            width: 84px;
            height: 84px;

            @media (max-width: 375px) {
              width: 64px;
              height: 64px;
            }
          }
        }

        .cover-description {
          display: inline-block;
          vertical-align: top;
          background-color: #ffffff;
          padding: 12px;
          box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.1);
          vertical-align: top;

          @media (max-width: 375px) {
            padding: 8px;
          }

          span {
            font-size: 14px;
            font-weight: 500;
            padding: 2px;
            color: #000000;
            overflow: hidden; 
            text-overflow: ellipsis; 
            white-space: nowrap;
            @media (max-width: 375px) {
              font-size: 12px;
            }
          }
        }
      }
    }

    .domain-container {
      max-width: 946px;
      margin: 0 auto;

      .domain-state-icon {
        position: absolute;
        right: 6px;
        border-right: 12px solid transparent;
        border-bottom: 12px solid;
        background-color: rgba(0, 0, 0, 0.1);
      }

      .domain-title {
        padding: 20px 14px 20px 14px;
        font-size: 18px;
      }

      .domain {
        margin: 6px 0px 6px 0px;
        padding-left: 6px;
        padding-right: 6px;
        position: relative;

        .domain-name {
          font-size: 18px;
          color: rgba(0, 0, 0, 0.87);
          font-weight: 500;
          padding: 14px;
        }

        .domain-state {
          padding: 14px;
          font-size: 16px;
          font-weight: 500;

          .domain-progress {
            color: rgba(0, 0, 0, 0.38);
          }

          .domain-score {
            color: rgba(0, 0, 0, 0.38);
          }

          .domain-action {
            text-align: right;

            span {
              cursor: pointer;
            }
          }

          .domain-progress-bar {
            padding: 12px 0px 12px 0px;
          }
        }
      }
    }
  }
</style>


// WEBPACK FOOTER //
// CatDomainView.vue?3c22b51e